<template>
    <div>
        
    </div>
</template>

<script>
import VueEvent from "../../api/eventBus"
    export default {
        mounted(){
            VueEvent.$off("val")
            VueEvent.$on('val', function(data){
                if(data == 3){
                this.$notify({
                    message: '暂无举报权限',
                    duration: 3000
                });
                }
            })
        },

        methods: {
            beforeDestroy() {
                VueEvent.$off();
    　　　　}
        }
}
</script>

<style lang="less" scoped>
</style>
